if (!customElements.get('main-filters')) {
  class MainFilters extends HTMLElement {
    constructor() {
      super();

      this.details = [];
      this.onToggle = this.onToggle.bind(this);
      this.onClickOutside = this.onClickOutside.bind(this);
      this.onInputChange = this.onInputChange.bind(this);
    }

    connectedCallback() {
      this.details = Array.from(this.querySelectorAll('details'));

      this.details.forEach((detail) => {
        detail.addEventListener('toggle', this.onToggle);
      });

      this.addEventListener('change', this.onInputChange);
      document.addEventListener('click', this.onClickOutside);
    }

    disconnectedCallback() {
      this.details.forEach((detail) => {
        detail.removeEventListener('toggle', this.onToggle);
      });

      this.removeEventListener('change', this.onInputChange);
      document.removeEventListener('click', this.onClickOutside);
    }

    onToggle(event) {
      const opened = event.target;

      if (!opened.open) return;

      this.details.forEach((detail) => {
        if (detail !== opened) {
          detail.open = false;
        }
      });
    }

    onClickOutside(event) {
      const closestWrapper = event.target.closest('li');
      if (this.contains(event.target) || closestWrapper) return;
      this.details.forEach((detail) => {
        detail.open = false;
      });
    }

    onInputChange(event) {
      const input = event.target.closest('input[data-sync-input-id]');
      if (!input) return;

      const targetInput = document.getElementById(input.dataset.syncInputId);
      if (!targetInput) return;

      if (targetInput.type === 'checkbox' || targetInput.type === 'radio') {
        targetInput.checked = input.checked;
      } else {
        targetInput.value = input.value;
      }

      targetInput.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  customElements.define('main-filters', MainFilters);
}
